<template>
	<div>
		<button
			class="image-modal__button"
			@click="toggleModal"
			aria-label="Öppna modal"
		>
			<picture>
				<div class="image-modal__wrapper">
					<img v-if="src" :src="src" class="image-modal__image" />
				<v-icon name="icon-zoom-in" class="image-modal__zoom-in"/>
				</div>
				<figcaption></figcaption>
			</picture>
		</button>
		<v-modal v-if="showModal" :close="toggleModal" :isImageModal="true"
			><template v-slot:content><img :src="modalSrc" /> </template
		></v-modal>
	</div>
</template>

<script>
import VIcon from "../../components/icon/VIcon";
import VModal from "../../components/modal/VModal";

export default {
	name: "VImageModal",
	components: {
		VIcon,
		VModal
	},
	props: {
		src: {
			type: String,
			default: ""
		},
		modalSrc: {
			type: String,
			default: () => {}
		}
	},
	data() {
		return {
			showModal: false
		};
	},
	methods: {
		toggleModal() {
			this.showModal = !this.showModal;
			if (this.showModal === true) {
				document.body.style.overflow = "hidden";
			}
			if (this.showModal === false) {
				document.body.style.overflow = "auto";
			}
		}
	}
};
</script>
